import React, {Component} from 'react';
import './PCBWithStencilForm.css';
import '../../../../Common/Common.css';
import StencilFramework from "./PCBWithStencilFormFields/StencilFramework";
import StencilDimensions from "./PCBWithStencilFormFields/StencilDimensions";
import StencilSide from "./PCBWithStencilFormFields/StencilSide";
import StencilQuantity from "./PCBWithStencilFormFields/StencilQuantity";
import StencilElectroPolishing from "./PCBWithStencilFormFields/StencilElectroPolishing";
import StencilFiducials from "./PCBWithStencilFormFields/StencilFiducials";
import StencilCustomizedSize from "./PCBWithStencilFormFields/StencilCustomizedSize";
import StencilRemarks from "./PCBWithStencilFormFields/StencilRemarks";

class PCBWithStencilForm extends Component {
    constructor(props) {
        super(props);

        this.setPCBWithStencilParams = this.setPCBWithStencilParams.bind(this);
        this.setParameters = this.setParameters.bind(this);
    }

    setParameters = (event) => {
        if (event.target.name === "dimension") {
            this.props.setDimensions(event);
        } else if (event.target.name === "stencil_qty") {
            const pattern = /^[1-9]([0-9]*)?$/;
            // const pattern = /^[0-9\b]+$/;
            if (event.target.value.match(pattern)) {
                this.props.setQuantity(event);
                // console.log("DONE DUO");
            }else if(event.target.value===""){
                this.props.setQuantity(event);

            }
        } else if (event.target.name === "stencilRemarks") {
            this.props.setRemarks(event);
        }
    };

    setPCBWithStencilParams = (param) => {
        param.map((paramData) => {
            if (paramData.checked) {
            }
        });
    };

    render() {
        const displayStyle = {
            display: 'block'
        };

        return (
            <div className="pcb-with-stencil-div">

                <div style={displayStyle}>

                    <StencilFramework setStencilParams={this.props.setStencilParams}
                                      selectedId={this.props.quotation.smtStencilParam.framework}/>

                    <StencilDimensions setParameters={this.setParameters}
                                       selectedId={this.props.quotation.smtStencilParam.dimensionsID}
                                       stnclParams={this.props.quotation.smtStencilParam.framework}/>

                    <StencilSide setStencilParams={this.props.setStencilParams}
                                 selectedId={this.props.quotation.smtStencilParam.stencilSide}
                                 quotation={this.props.quotation}/>

                    <StencilQuantity setQuantity={this.setParameters}
                                     selectedId={this.props.quotation.smtStencilParam.stencilQty}
                                     stnclParams={this.props.quotation.smtStencilParam.stencilSide}/>

                    <StencilElectroPolishing setStencilParams={this.props.setStencilParams}
                                             selectedId={this.props.quotation.smtStencilParam.electropolishing}/>

                    <StencilFiducials setStencilParams={this.props.setStencilParams}
                                      selectedId={this.props.quotation.smtStencilParam.fiducials}/>

                    {this.props.quotation.smtStencilParam.framework === 0 ?

                        <StencilCustomizedSize setStencilParams={this.props.setStencilParams}
                                               selectedId={this.props.quotation.smtStencilParam.customizeFlag}
                                               stnclParams={this.props.quotation.smtStencilParam.framework}
                                               quotation={this.props.quotation}/> :''
                    }

                    <StencilRemarks setParameters={this.setParameters}
                                    remarks={this.props.quotation.smtStencilParam.orderRemark}/>

                </div>
            </div>
        );
    }

}

export default PCBWithStencilForm;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBWithStencilForm/PCBWithStencilForm.js